<div #container>

  <div class="grid-x grid-margin-x">
    <div class="cell">
      <h1 [innerHTML]="'moderat.sanierung.headline' | translate"></h1>
      <p [innerHTML]="'moderat.sanierung.teaser.' + path | translate"></p>

      <div role="alert" class="form-errors" *ngIf="apiErrors.length > 0">
        <p [innerHTML]="'moderat.sanierung.error' | translate"></p>
        <ul>
          <li *ngFor="let error of apiErrors" [innerHTML]="error | translate: errorPlaceholder()"></li>
        </ul>
      </div>
    </div>
  </div>

  @if(forceDialog || showDownload) {
    <dialog-hint clickTarget="nextSteps" class="pdf-hint" textkey="moderat.sanierung.callout"
                 [closable]="true"></dialog-hint>
  }
  <div #sidebarContainer class="grid-x grid-margin-x result-wrapper">
    <div class="cell small-12 medium-5 medium-order-2">
      <aside #sidebar class="medium-fixed-wrapper" [class.fixed]="sidebarOffset > 0" [style.top]="sidebarOffset + 'px'">
        <mat-accordion multi>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h3 [innerHTML]="'moderat.sanierung.saving.headline' | translate"></h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="loading over" *ngIf="!consumptionData"></div>
            <div class="grid-x savings-wrapper" *ngFor="let unit of ['kwh', 'co2']">
              <div class="cell hide-for-medium">
                <span class="gray text-normal" [innerHTML]="'moderat.sanierung.saving.current.mobile.' + unit | translate"></span>{{' '}}
                <span class="gray hide-fixed" [innerHTML]="'moderat.sanierung.saving.current' | translate"></span><span class="hide-fixed">{{' / '}}</span>
                <span class="hide-fixed primary" [innerHTML]="'moderat.sanierung.saving.sanitized' | translate"></span>
                <small class="show-fixed" [innerHTML]="'moderat.sanierung.unit.' + unit | translate"></small>
              </div>
              <div class="cell show-for-medium auto gray" [innerHTML]="'moderat.sanierung.saving.current.' + unit | translate"></div>
              <div class="cell shrink show-for-medium text-right gray" [innerHTML]="'moderat.sanierung.unit.' + unit | translate"></div>
              <div class="cell small-12 hide-fixed">
                <span class="saving-bar gray full"
                      [style.width]="(consumption[unit].percent <= 1 && consumption[unit].current > 0) ? '100%' : (consumption[unit].current / consumption[unit].sanitized) * 100 + '%'"
                      [class.unit-zero]="consumption[unit].current === 0">
                  {{consumption[unit].current | number: (unit === 'kwh'? '1.0-0' : '1.0-1')}}
                  <small class="hide-for-medium" [innerHTML]="'moderat.sanierung.unit.' + unit | translate"></small>
                </span>
              </div>
              <div class="cell small-12 hide-fixed">
                <span class="saving-bar primary" aria-live="polite" [style.width]="
                   (consumption[unit].sanitized === 0) ? '0%'
                   : (consumption[unit].percent <= 1 && consumption[unit].sanitized > 0) ? (consumption[unit].percent * 100) + '%'
                   : '100%'">
                  {{(consumption[unit].sanitized > 0 && consumption[unit].sanitized < 0.1) ? '<0,1' : consumption[unit].sanitized | number: (unit === 'kwh'? '1.0-0' : '1.0-1')}}
                  <small class="hide-for-medium" [innerHTML]="'moderat.sanierung.unit.' + unit | translate"></small>
                </span>
              </div>
              <div class="cell hide-for-medium show-fixed">
                <span class="saving-bar primary" aria-live="polite" [style.width]="
                  (consumption[unit].current === consumption[unit].sanitized) ? '50%'
                  : (consumption[unit].current === 0 && consumption[unit].sanitized > 0) ? '90%'
                  : (consumption[unit].sanitized === 0 && consumption[unit].current > 0) ? '10%'
                  : (consumption[unit].percent >= 1) ? 100 - (consumption[unit].current / consumption[unit].sanitized) * 100 + '%'
                  : (consumption[unit].percent * 100) + '%'">
                  {{consumption[unit].sanitized | number: (unit === 'kwh'? '1.0-0' : '1.0-1')}}
                </span>
                <span class="saving-bar gray" [style.width]="
                  (consumption[unit].current === consumption[unit].sanitized) ? '50%'
                  : (consumption[unit].current === 0 && consumption[unit].sanitized > 0) ? '10%'
                  : (consumption[unit].sanitized === 0 && consumption[unit].current > 0) ? '90%'
                  : (consumption[unit].percent >= 1) ? (consumption[unit].current / consumption[unit].sanitized) * 100 + '%'
                  : (100 - (consumption[unit].percent * 100)) + '%'">
                  {{consumption[unit].current | number: (unit === 'kwh'? '1.0-0' : '1.0-1')}}
                </span>
              </div>
              <div class="cell small-12 show-for-medium primary" [innerHTML]="'moderat.sanierung.saving.sanitized.' + unit | translate"></div>
              <small class="cell hide-for-medium show-fixed">
                <span class="primary" [innerHTML]="'moderat.sanierung.saving.sanitized' | translate"></span>{{' / '}}
                <span class="gray" [innerHTML]="'moderat.sanierung.saving.current' | translate"></span>
              </small>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true" class="show-for-medium">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h3 [innerHTML]="'moderat.sanierung.costs.headline' | translate"></h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="loading" *ngIf="!costs"></div>
            <table *ngIf="costs">
              <thead>
                <tr>
                  <th class="sr-only" [innerHTML]="'moderat.sanierung.costs.kategorie' | translate"></th>
                  <th class="sr-only" [innerHTML]="'moderat.sanierung.costs.wert' | translate"></th>
                </tr>
              </thead>
                <tbody>
                <tr>
                  <td [innerHTML]="'moderat.sanierung.costs.investitionen' | translate"></td>
                  <td aria-live="polite">{{(costs.overall.sum * 1) | number: '1.0-0'}} €</td>
                </tr>
                <tr>
                  <td [innerHTML]="'moderat.sanierung.costs.funding_grants' | translate"></td>
                  <td aria-live="polite">{{(costs?.funding_grants.sum) * 1 | number: '1.0-0'}} €</td>
                </tr>
                <tr class="border">
                  <td [innerHTML]="'moderat.sanierung.costs.monthly' | translate"></td>
                  <td aria-live="polite">{{(costs.monthly_balance.sum) * 1 | number: '1.0-0'}} €</td>
                </tr>
              </tbody>
            </table>
            <button type="button" class="details-button" (click)="showFinanceDetails()" [innerHTML]="'moderat.sanierung.show_details' | translate"></button>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="showRecommandSection" (afterCollapse)="showRecommandSection = false" class="show-for-medium">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h3 [innerHTML]="'moderat.sanierung.recommendation.headline' | translate"></h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p *ngFor="let warning of apiWarnings" [innerHTML]="('moderat.sanierung.recommendation.warning.' + warning) | translate"></p>
            <p [innerHTML]="recommendTextkey | translate: recommendPlaceholders"></p>
            <button *ngIf="showResetButton === true" class="button primary" (click)="resetRecommandMeasures()"><i class="icon-check"></i><span>{{'moderat.sanierung.recommendation.button' | translate}}</span></button>
          </mat-expansion-panel>
        </mat-accordion>
      </aside>
    </div>

    <div class="cell small-12 medium-7 medium-order-1">


      <section class="measures-wrapper">
        <hr>
        <h2 [innerHTML]="'moderat.sanierung.massnahmen.headline' | translate"></h2>
        <hr>

        <fieldset>
          <div class="grid-x grid-margin-x insulation-header">
            <div class="cell small-6 medium-6">
              <legend [innerHTML]="'moderat.sanierung.massnahmen.daemmung.headline' | translate"></legend>
            </div>
            <div class="cell small-5 text-right">
              <span class="unit" [innerHTML]="'moderat.sanierung.unit.kwh.saving' | translate"></span>
            </div>
            <div class="cell small-1">
              <button type="button" class="help-button" (click)="showUnitHelp = !showUnitHelp" [attr.aria-expanded]="showUnitHelp" aria-controls="daemmung-help" [attr.aria-label]="'arialabel.toggle.help' | translate"><i class="icon-help-circle"></i></button>
            </div>
            <div class="cell small-12" *ngIf="showUnitHelp === true">
              <div class="callout">
                <button type="button" class="close" (click)="showUnitHelp = false" [attr.aria-label]="'arialabel.close' | translate"><i class="icon-x"></i></button>
                <div id="daemmung-help" [innerHTML]="'moderat.sanierung.massnahmen.daemmung.hilfe' | translate"></div>
              </div>
            </div>
          </div>

          <div class="loading" *ngIf="!measureData"></div>
          <div class="measure" *ngFor="let measure of measures.insulation">
            <app-moderat-sanierung-measure (onToggleText)="initSidebuttonOffset()" *ngIf="measureData && measureData[measure]" [measure]="measure" [inputType]="measure === 'passivhaus'? 'switch' : 'checkbox'"
                                           [maxSaving]="maxSaving.kwh" [form]="form" [formField]="measure" [saving]="measureData[measure].saving" savingUnit="kwh"
                                           [internalPortal]="internalPortal" [recommend]="measureData[measure].recommend"></app-moderat-sanierung-measure>
          </div>
        </fieldset>

        <hr>

        <fieldset>
          <div class="grid-x">
            <div class="cell small-6 medium-4">
              <legend [innerHTML]="'moderat.sanierung.massnahmen.heizung.headline' | translate"></legend>
            </div>
            <div class="cell small-6 medium-7 text-right">
              <span class="unit" [innerHTML]="'moderat.sanierung.unit.kwh.saving' | translate"></span>
            </div>
  <!--          <div class="cell small-6 medium-8 text-right">-->
  <!--            <div class="result-switch">-->
  <!--              <span [innerHTML]="'moderat.sanierung.switch.label' | translate"></span>-->
  <!--              <div class="switch" [class.right]="savingUnit === 'co2'" (click)="toggleSavinUnit()">-->
  <!--                <span [innerHTML]="'moderat.sanierung.switch.kwh' | translate"></span>-->
  <!--                <span></span>-->
  <!--                <span [innerHTML]="'moderat.sanierung.switch.co2' | translate"></span>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--          </div>-->
          </div>

          <div class="loading" *ngIf="!measureData"></div>
          <div class="measure" *ngFor="let measure of measures.heating">
            <app-moderat-sanierung-measure (onToggleText)="initSidebuttonOffset()" *ngIf="measureData && measureData[measure]" [value]="measure" [maxSaving]="savingUnit === 'co2'? maxSaving.co2 : maxSaving.kwh" inputType="radio" [measure]="measure"
                                           [internalPortal]="internalPortal" [form]="form" formField="heating" [textPostfix]="getTextPostfix(measure)"
                                           [saving]="getSaving(measure)" [savingUnit]="savingUnit" [recommend]="measureData[measure].recommend"></app-moderat-sanierung-measure>
          </div>
        </fieldset>
        <hr>

        <fieldset>
          <div class="grid-x grid-margin-x">
            <div class="cell small-6 medium-6">
              <legend [innerHTML]="'moderat.sanierung.massnahmen.technik.headline' | translate"></legend>
            </div>
            <div class="cell small-6 medium-5 text-right">
              <span class="unit" [innerHTML]="'moderat.sanierung.unit.kwh.saving' | translate"></span>
            </div>
          </div>

          <div class="loading" *ngIf="!measureData"></div>
          <div class="measure" *ngFor="let measure of measures.additional">
            <app-moderat-sanierung-measure (onToggleText)="initSidebuttonOffset()" *ngIf="measureData && measureData[measure]" [measure]="measure" [maxSaving]="maxSaving.kwh" [form]="form" [formField]="measure"
                                           [internalPortal]="internalPortal" [saving]="measureData[measure].saving" savingUnit="kwh" [recommend]="measureData[measure].recommend"></app-moderat-sanierung-measure>
          </div>
        </fieldset>
      </section>

      <section class="climate-wrapper">
        <app-sanierung-co2 [consumption]="consumption"></app-sanierung-co2>
      </section>

      <section class="costs-wrapper" id="costs">
        <h2 [innerHTML]="'moderat.sanierung.finanzierung.headline' | translate"></h2>
        <p [innerHTML]="'moderat.sanierung.finanzierung.teaser' | translate"></p>

        <mat-accordion multi >
          <mat-expansion-panel [expanded]="financeToggle" (afterExpand)="afterExpandCollapseFinancePanel(true)" (afterCollapse)="afterExpandCollapseFinancePanel(false)">
            <mat-expansion-panel-header>
              <mat-panel-title><h3 [innerHTML]="'moderat.sanierung.finanzierung.investition.headline' | translate"></h3></mat-panel-title>
            </mat-expansion-panel-header>
            <app-sanierung-invest [costs]="costs" [costChanges]="costsChanges"></app-sanierung-invest>
          </mat-expansion-panel>

          <mat-expansion-panel (afterExpand)="initSidebuttonOffset()" (afterCollapse)="initSidebuttonOffset()">
            <mat-expansion-panel-header>
              <mat-panel-title><h3 [innerHTML]="'moderat.sanierung.finanzierung.wirtschaftlichkeit.headline' | translate"></h3></mat-panel-title>
            </mat-expansion-panel-header>
            <app-sanierung-economic [costs]="costs" [costChanges]="costsChanges"></app-sanierung-economic>
          </mat-expansion-panel>

          <mat-expansion-panel (afterExpand)="initSidebuttonOffset()" (afterCollapse)="initSidebuttonOffset()">
            <mat-expansion-panel-header>
              <mat-panel-title><h3 [innerHTML]="'moderat.sanierung.finanzierung.co2.headline' | translate"></h3></mat-panel-title>
            </mat-expansion-panel-header>
            <app-sanierung-co2costs [co2Costs]="costs?.co2" [co2CostChanges]="costsChanges"></app-sanierung-co2costs>
          </mat-expansion-panel>
        </mat-accordion>
      </section>
    </div>
  </div>
</div>

<div class="grid-container nextsteps-container" #nextStepsContainer>
  @if(forceDialog || showDownload) {
    <div id="nextSteps" class="grid-x grid-margin-x">
      <div class="cell small-12 medium-7">
        <section class="nextsteps-wrapper" [class.internal]="internalPortal" *ngIf="apiErrors.length === 0">
          <h2 [innerHTML]="'moderat.sanierung.nextsteps.headline' | translate"></h2>
          <p [innerHTML]="'moderat.sanierung.nextsteps.teaser' | translate"></p>
        </section>
      </div>
    </div>
  }

  <div class="grid-x grid-margin-x">
    <div class="cell small-12">
      <section class="dialog" *ngIf="forceDialog">
        <app-dialogform textkeyPrefix="moderat.naechsteschritte" advisorImagePath="/moc/moc-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)"></app-dialogform>
      </section>

      <section class="download-wrapper" *ngIf="showDownload">
        <app-download [url]="anfrage.measureResult.report" textkeyPrefix="moderat.naechsteschritte."></app-download>
      </section>

      <section class="faq-wrapper" *ngIf="faqTopics.length > 0">
          <div class="cell small-12">
            <h2 [innerHTML]="'moderat.sanierung.modernisierung.headline' | translate"></h2>
          </div>

          <div class="cell">
            <mat-accordion multi>
              <mat-expansion-panel *ngFor="let row of faqTopics;" [expanded]="faqTopics.length === 1">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 [innerHTML]="'moderat.sanierung.' + row + '.headline' | translate"></h3>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div [innerHTML]="'moderat.sanierung.' + row + '.text' | translate: {eur: costs?.funding_grants.sum * 1 | number: '1.0-0'}"></div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
      </section>

      <section class="portal">
        <app-portal-teaser></app-portal-teaser>
      </section>

      <section class="donate-wrapper" *ngIf="internalPortal === true">
        <app-donate textkeyPrefix="moderat"></app-donate>
      </section>
    </div>
  </div>

  <button #sideButton class="button primary scroll-up-button" aria-hidden="true" [class.fixed]="sideButtonOffset > 0" [style.top]="sideButtonOffset + 'px'" (click)="scrollToTop()" [innerHTML]="'moderat.sanierung.back.to.result' | translate"></button>
</div>

<app-step-buttons [previousLink]="previousLink" mediumWidthRight="8" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="5" previousText="step.button.previous" [nextLink]="this.showResetRequestButton? '../../einstieg' : null" nextText="step.button.newrequest" [nextSubmit]="false" (onNextClick)="resetRequest()"></app-step-buttons>

